<!-- <a-table
  row-key="id"
  size="small"
  :bordered="true"
  :data-source="fileList"
  :columns="columns"
  :scroll="{ x: true }"
  :pagination="pagination"
  @change="onTableChange"
  class="a-table"
> -->
<table-wrapper
  :dataSource="fileList"
  @onTableChange="onTableChange"
  :pagination="pagination"
  :columns="columns"
  :showCheckbox="false"
  :tableHeight="tableHeight"
>
  <template #size="{ record }">
    <span>{{ $filters.humanizeFileSize(record.size) }}</span>
  </template>
  <template #operation="{ record }">
    <a-space>
      <span @click="downloadFile(record)" class="download-class theme-color">下载</span>
      <img-preview-btn :key="record.id" :url="record.url"></img-preview-btn>
      <template v-if="allowEdit">
        <delete-btn
          v-perm="deleteAccess"
          :key="record.id"
          :id="record.id"
          @refresh="refresh"
        ></delete-btn>
      </template>
    </a-space>
  </template>
</table-wrapper>
